<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-if="isAdmin || isAgent" v-model="query.companyId" @change="companyChange"
					filterable clearable placeholder="企业" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" class="m_r_10"></el-date-picker>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
					@click="getData()">搜索</el-button>
				<el-button size="small" type="primary" :class="[theme]" @click="handleDownload">导出</el-button>
			</div>

			<el-row :gutter="24" type="flex" class="row-bg" justify="space-between">
				<el-col :span="24">
					<div class="card-body">
						<div class="tit">
							<div><i class="el-icon-s-data"></i>外呼数据展示</div>

						</div>
						<div class="card-list">
							<div class="bg_f0f2f5">
								<span>拨打数量</span>
								<span>{{overallStats.totalCall||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span>接通数量</span>
								<span>{{overallStats.pickUp||0}}</span>
							</div>
							<div class="bg_dfeef3">
								<span>通话分钟数</span>
								<span>{{overallStats.carrierCallDuration||0}}</span>
							</div>
							<div class="bg_f8f0f9">
								<span>平均通话时长
									<el-tooltip content="平均通话时长" placement="top">
										<i class="el-icon-warning-outline"
											style="color: #f27c27;position: relative;top:-4px;left: 6px;cursor: pointer;"></i>
									</el-tooltip>
								</span>
								<span>{{overallStats.averageDuration||0}}</span>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" @selection-change="handleSelectionChange"
				:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
				:cell-style="{ padding: '6px' }" stripe v-loading="loading">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="agentName" label="代理商" align="center" width="180"
					v-if="isAdmin"></el-table-column>
				<el-table-column prop="companyName" label="企业名称" align="center"></el-table-column>
				<el-table-column prop="cardName" label="行业" align="center"></el-table-column>
				<el-table-column prop="totalCall" label="外呼数量" align="center"></el-table-column>
				<el-table-column prop="pickUp" label="接通数量" align="center"></el-table-column>
				<el-table-column prop="pickUpRate" label="接通率" align="center">
					<template #default="scope">
						<span>{{scope.row.pickUpRate*100||0}}%</span>
					</template>
				</el-table-column>
				<el-table-column prop="carrierCallDuration" label="通话分钟数" align="center"></el-table-column>
				<el-table-column prop="averageDuration" label="平均通话时长" align="center"></el-table-column>
			</el-table>

			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		callData
	} from '../api/setMeal.js';
	import {
		fetchAgent
	} from '../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		fetchDepartment,
		fetchUsersByDepartmentId,
		fetchDefaultUsers
	} from '../api/index.js';
	export default {
		name: 'quantitativeIntelligenceMonitoring',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					userId: localStorage.getItem('user'),
					agentId: '',
					companyId: '',
					cardsId: '',
					pageIndex: 1,
					pageSize: 10,
				},
				agents: [],
				companys: [],
				tableData: [],
				overallStats: '',
				multipleSelection: [],
				isAdmin: false,
				isAgent: false,
				isNormal: false,
				pageTotal: 0,
				role: '',
				timeArr: []
			};
		},
		created() {
			this.role = localStorage.getItem('ms_role');
			if (this.role === 'admin') {
				this.isAdmin = true;
			}
			if (this.role == 'agent') {
				this.isAgent = true;
			}
			if (this.role == 'normal') {
				this.isNormal = true;
			}
			this.init();
			this.getTime();
			this.getData();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle(){
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			getTime() {
				//时间
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr.push(startTime);
				this.timeArr.push(endTime);
			},
			toDateTimeStr(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				if (d < 10) {
					d = '0' + d;
				}
				return y + '-' + m + '-' + d;
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			getData() {
				if (this.timeArr === null) {
					this.query.startTime = '';
					this.query.endTime = '';
					this.$message.error('时间不能为空');
				} else {
					let startTime = this.toDateTimeStr(this.timeArr[0]);
					let endTime = this.toDateTimeStr(this.timeArr[1]);
					this.query.startTime = startTime;
					this.query.endTime = endTime;
				}
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query.agentId,
					companyId: this.query.companyId,
					cardsId: this.query.cardsId,
					endTime: this.query.endTime,
					startTime: this.query.startTime,
					pageIndex: this.query.pageIndex,
					pageSize: this.query.pageSize,

				};
				this.loading = true;
				callData(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.companyStats;
						this.overallStats = res.data.overallStats;
					} else {
						this.$message.error(res.message);
					}
				});
			},


			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					if (this.role == 'company' || this.role == 'department') {
						let data = {
							companyId: '',
							currentUserId: localStorage.getItem('user')
						};
						fetchDepartment(data).then(res => {
							this.departments = res.data;
						});
					} else {
						this.companys = res.data;
					}
				});
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				this.query.departmentId = '';
				this.query.userId = '';
				this.query.packageMinutes = '';
				this.packageList = [];
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				} else {
					this.departments = [];
				}
			},
			//导出
			handleDownload() {
				this.loading = true;
				this.query.company = localStorage.getItem('company');
				// aaa(this.query).then(res => {
				// 	if (res.type == 'application/json') {
				// 		return this.$message.error(res.message)
				// 	}
				// 	const blob = new Blob([res], {
				// 		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
				// 	});
				// 	let downloadElement = document.createElement('a');
				// 	let href = window.URL.createObjectURL(blob);
				// 	downloadElement.href = href;
				// 	let fileName = '客质精控' + '.xlsx';
				// 	downloadElement.download = fileName;
				// 	document.body.appendChild(downloadElement);
				// 	downloadElement.click();
				// 	document.body.removeChild(downloadElement);
				// 	window.URL.revokeObjectURL(href);
				// 	this.loading = false;
				// });
			},
		}
	};
</script>

<style scoped>
	.row-bg {
		padding-right: 12px;
		margin-bottom: 12px;
	}

	.card-body {
		color: rgba(0, 0, 0, 0.65);
		background: #fff;
		border-radius: 2px;
		box-sizing: border-box;
		padding: 24px 0;

	}

	.card-body .tit {
		font-weight: 700;
		color: rgba(0, 0, 0, 0.85);
		margin-bottom: 1em;
		font-size: 14px;
		font-variant: tabular-nums;
		line-height: 1.5;
		list-style: none;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.el-icon-s-data,
	.el-icon-postcard,
	.el-icon-finished {
		font-size: 20px;
		margin-right: 5px;
		color: #1890FF;
	}

	.card-body .card-list {
		display: flex;
		flex-direction: row;
	}

	.card-body .card-list div {
		padding-left: 12px;
		padding-right: 12px;
		padding: 24px;
		zoom: 1;
		width: 23%;
		display: flex;
		flex-direction: column;
		margin-right: 2%;

	}

	.card-body .tit .tit-btn .active {
		color: #fff;
	}

	.card-body .card-list div>span:first-child {
		font-size: 14px;
		color: rgba(0, 0, 0, 0.65);
	}

	.card-body .card-list div>span:last-child {
		font-size: 24px;
		margin-top: 10px;
		font-weight: 700;
	}

	.bg_eff5f7 {
		background: #eff5f7;
	}

	.bg_dfeef3 {
		background: #dfeef3;
	}

	.bg_f8f0f9 {
		background: #f8f0f9;
	}

	.bg_f0f2f5 {
		background: #f0f2f5;
	}
</style>